import { t as e } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { DialtoneLocalization as t } from "../../localization/index.js";
import n from "../collapsible/collapsible.js";
import r from "../item-layout/item-layout.js";
import { FEED_ITEM_PILL_BORDER_COLORS as i } from "./feed-item-pill-constants.js";
import { createBlock as a, createElementBlock as o, createElementVNode as s, createSlots as c, createVNode as l, normalizeClass as u, normalizeStyle as d, openBlock as f, renderSlot as p, resolveComponent as m, resolveDynamicComponent as h, toDisplayString as g, withCtx as _ } from "vue";
import { DtIconChevronDown as v, DtIconChevronRight as y } from "@dialpad/dialtone-icons/vue";
//#region recipes/conversation_view/feed_item_pill/feed_item_pill.vue
var b = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeFeedItemPill",
	components: {
		DtItemLayout: r,
		DtCollapsible: n
	},
	props: {
		title: {
			type: String,
			default: () => ""
		},
		buttonClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		toggleable: {
			type: Boolean,
			default: () => !0
		},
		defaultToggled: {
			type: Boolean,
			default: () => !1
		},
		borderColor: {
			type: String,
			default: "default",
			validator: (e) => Object.keys(i).includes(e)
		}
	},
	data() {
		return {
			hover: !1,
			expanded: this.defaultToggled,
			i18n: new t()
		};
	},
	computed: {
		toggleIcon() {
			return this.expanded ? v : y;
		},
		showChevronIcon() {
			return this.toggleable && this.hover;
		},
		toggleableClass() {
			return this.toggleable ? "d-recipe-feed-item-pill--toggleable" : "";
		},
		borderClass() {
			return i[this.borderColor];
		},
		anchorTitle() {
			return this.i18n.$t("DIALTONE_FEED_ITEM_PILL_ARIA_LABEL");
		}
	},
	methods: { onClick() {
		this.toggleable && (this.expanded = !this.expanded);
	} }
}, x = { class: "d-recipe-feed-item-pill__wrapper" }, S = ["aria-label", "title"], C = { class: "d-recipe-feed-item-pill__title" }, w = {
	class: "d-recipe-feed-item-pill__icon",
	"data-qa": "dt-recipe-feed-item-pill__icon"
}, T = { class: "d-recipe-feed-item-pill__subtitle" }, E = { class: "d-recipe-feed-item-pill__bottom" }, D = { class: "d-recipe-feed-item-pill__right" }, O = { class: "d-recipe-feed-item-pill__content" };
function k(e, t, n, r, i, v) {
	let y = m("dt-item-layout"), b = m("dt-collapsible");
	return f(), o("div", {
		class: u([
			"d-recipe-feed-item-pill__border",
			v.borderClass,
			e.$attrs.class
		]),
		style: d(e.$attrs.style)
	}, [s("div", x, [l(b, { open: i.expanded }, c({
		anchor: _(() => [s("button", {
			"data-qa": "dt-recipe-feed-item-pill",
			class: u([
				"d-recipe-feed-item-pill__button",
				v.toggleableClass,
				n.buttonClass
			]),
			"aria-label": v.anchorTitle,
			title: v.anchorTitle,
			onFocusin: t[0] || (t[0] = (e) => i.hover = !0),
			onFocusout: t[1] || (t[1] = (e) => i.hover = !1),
			onMouseenter: t[2] || (t[2] = (e) => i.hover = !0),
			onMouseleave: t[3] || (t[3] = (e) => i.hover = !1),
			onClick: t[4] || (t[4] = (...e) => v.onClick && v.onClick(...e))
		}, [l(y, {
			class: "d-recipe-feed-item-pill__layout",
			unstyled: ""
		}, c({
			start: _(() => [s("div", w, [v.showChevronIcon ? (f(), a(h(v.toggleIcon), {
				key: 0,
				size: "300"
			})) : e.$slots.startIcon ? p(e.$slots, "startIcon", {
				key: 1,
				iconSize: "300"
			}) : p(e.$slots, "leftIcon", {
				key: 2,
				iconSize: "300"
			})])]),
			default: _(() => [p(e.$slots, "title", {}, () => [s("span", C, g(n.title), 1)])]),
			_: 2
		}, [
			e.$slots.subtitle ? {
				name: "subtitle",
				fn: _(() => [s("div", T, [p(e.$slots, "subtitle")])]),
				key: "0"
			} : void 0,
			e.$slots.blockEnd || e.$slots.bottom ? {
				name: "blockEnd",
				fn: _(() => [s("div", E, [e.$slots.blockEnd ? p(e.$slots, "blockEnd", { key: 0 }) : p(e.$slots, "bottom", { key: 1 })])]),
				key: "1"
			} : void 0,
			e.$slots.end || e.$slots.right ? {
				name: "end",
				fn: _(() => [s("div", D, [e.$slots.end ? p(e.$slots, "end", { key: 0 }) : p(e.$slots, "right", { key: 1 })])]),
				key: "2"
			} : void 0
		]), 1024)], 42, S)]),
		_: 2
	}, [e.$slots.content ? {
		name: "content",
		fn: _(() => [s("div", O, [p(e.$slots, "content")])]),
		key: "0"
	} : void 0]), 1032, ["open"])])], 6);
}
var A = /* @__PURE__ */ e(b, [["render", k]]);
//#endregion
export { A as default };

//# sourceMappingURL=feed-item-pill.js.map